angular.module('cvsApp').service('portalService',['networkService', 'xdrService', 'configManager', 'cvsAppData', function (NS, XS, CM, CAD) {
	   
	function portalService (){	
		this.callPortal = function(callBackSuccess, callBackFailure, actionId){

			if(CVS.Config.portalSessionIds[actionId]){
				var request = {
					url:CAD.getPortalSession().portalSessionUrl+'/id='+ CVS.Config.portalSessionIds[actionId] +'/c=cacheLevelPage/=/',
					header:{
						"Content-Type":"application/xml"
					},
					onSuccess:callBackSuccess,
					onError:callBackFailure
				}

				var promise = NS.post(request);
				promise.then(function(data, c, d){
					callBackSuccess(data.data);
				});
				promise.error(function(reason) {
					callBackFailure(reason);
				  });	
			}
									
		}

	}
	
	return new portalService();	
}]);
